(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-brands-list]');
    if (!root) return;

    var sections = Array.prototype.slice.call(root.querySelectorAll('.brands-list__letter'));
    var navItems = Array.prototype.slice.call(root.querySelectorAll('[data-nav-letter]'));
    var searchInput = root.querySelector('[data-brands-search]');
    var emptyState = root.querySelector('[data-empty-state]');

    // --- Search / type-ahead filter ---
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var q = searchInput.value.trim().toLowerCase();
        var anyVisible = false;

        sections.forEach(function (sec) {
          var cards = sec.querySelectorAll('.brand-card');
          var sectionHas = false;
          cards.forEach(function (card) {
            var name = (card.getAttribute('data-brand-name') || '').toLowerCase();
            var match = !q || name.indexOf(q) !== -1;
            card.classList.toggle('is-hidden', !match);
            if (match) sectionHas = true;
          });
          sec.classList.toggle('is-hidden', !sectionHas);
          if (sectionHas) anyVisible = true;
        });

        if (emptyState) emptyState.hidden = anyVisible || !q;
      });
    }

    // --- Smooth scroll to letter on jump-bar click ---
    // scroll-margin-top on .brands-list__letter handles the offset for the
    // site's sticky header, so this just needs to fire the scroll.
    navItems.forEach(function (item) {
      if (item.tagName !== 'A') return;
      item.addEventListener('click', function (e) {
        var href = item.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', href);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
